import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class ThemeService {

  constructor() { }

  updateThemeUrl(theme: string) {
    console.log("---------> set theme/colors", theme)
    document.getElementsByTagName("body")[0].className = theme;
    localStorage.setItem("theme", JSON.stringify(theme));
  }

  // setElementBackground(color:string){
  //   if(color === ''){
  //     document.getElementById('').style()
  //   }
  // }
}
